export const EXPANDED_LIST_HEADER_HEIGHT = 197
export const LIST_SECTION_HEADER_HEIGHT = 32
export const LIST_VERTICAL_PADDINGS = 92

export const VIDEO_CALLS_UPSELL_MODAL_DELAY_DAYS = 3
export const MENTAL_HEALTH_SERVICES_INTEREST_SURVEY_DELAY_DAYS = 2
export const DELAY_TIME_IN_MILLISECONDS = 72 * 60 * 60 * 1000 // 72 hours in milliseconds
export const TESTING_DELAY_TIME_IN_MILLISECONDS = 5 * 60 * 1000 // 5 minutes in milliseconds

export enum ByosVideoCallsUpsellStep {
  InitialModal = 'initial_modal',
  AfterInitialModal = 'after_initial_modal',
  ChatlikeNotification = 'chatlike_notification',
  ActionItem = 'action_item',
  FreeConsultationModal = 'free_consultation_modal',
  AfterFreeConsultationModal = 'after_free_consultation_modal',
  FreeConsultationChatlikeNotification = 'free_consultation_chatlike_notification',
  FreeConsultationActionItem = 'free_consultation_action_item',
}

interface OwnSensorGoalSurveyMap {
  [key: string]: string | undefined
}

export const OWN_SENSOR_GOAL_SURVEY_RESPONSE_MAP: OwnSensorGoalSurveyMap = {
  manage_pre_diabetes: 'managing pre diabetes/diabetes',
  chronic_fatigue: 'chronic fatigue/low energy levels',
  food_intolerances: 'intolerances/food allergies',
  cgm_data_interpretation: 'interpreting CGM data',
  mindful_eating: 'mindful eating/intuitive eating',
}
